/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { memo, Fragment, useEffect } from 'react';
import { Item } from 'semantic-ui-react';
import { isSameDate } from 'Helpers/utils';
import { useDispatch, useSelector } from 'react-redux';
import { setJumpMessage } from 'Redux/modules/webChat/messages/actions';
import AcceptedUnderInfo from 'Containers/Teleconsult/Main/Messages/MessageBody/MessageList/AcceptedUnderInfo';
import { MESSAGE_TYPE_REQUEST } from 'Constants/message-types';

import MessageItem from './MessageItem/MessageItem';
import MessageBotHOC from './MessageBot/MessageBotHOC';
import TimeDivider from './TimeDivider';
import ConsultDivider from './ConsultDivider';

const MessageList = props => {
  const {
    conversation,
    openMedicalCertificate,
    list,
    doctor,
    findOtherUser,
    handleLoadMore,
    onSetReply,
  } = props;

  const jumpMessage = useSelector(state => state.webChat.messages.jumpMessage);
  const dispatch = useDispatch();

  const patient = conversation?.latestConsult?.patient;

  let prevItem = null;
  let nextItem = {};
  let tempPrevItem = null;

  useEffect(() => {
    if (!!list?.length > 0 && !!jumpMessage) {
      if (list.map(e => e.id)?.includes(jumpMessage.id)) {
        document
          .getElementById(`message_${jumpMessage?.id}`)
          ?.scrollIntoView({ behavior: 'smooth' });
        setTimeout(() => {
          dispatch(setJumpMessage(null));
        }, 1000);
      } else {
        handleLoadMore();
      }
    }
  }, [jumpMessage, list]);

  return (
    <Item.Group className="message-list">
      {list?.map((item, index) => {
        const isCurrentDoctorMessage = item.user === doctor.userUuid;
        const isBotMessage = item.user === 'bot';
        const consultId = item.metadata?.consultId;

        // Notes: Because pending consult and conversation are using the same component.
        // And this info is only displayed in the pending consult.
        const isNewPendingRequest = !conversation && item.type === MESSAGE_TYPE_REQUEST;

        let avatarUrl = '';
        let fullName = '';

        // other user can be patient (in tab Patient Chat) or other doctor (in tab Doctor Chat)
        if (!isBotMessage && !isCurrentDoctorMessage) {
          const otherUser = findOtherUser(item.user);
          avatarUrl = otherUser.avatarUrl;
          fullName = otherUser.fullName;
        }

        const isNewConsult = prevItem && item.metadata.consultId !== prevItem.metadata.consultId;
        const hasDividerDate =
          (!prevItem || !isSameDate(prevItem.sentAt, item.sentAt)) && !isNewConsult;

        const isLastItem = index + 1 === list?.length;
        nextItem = isLastItem ? null : list[index + 1];

        tempPrevItem = prevItem;
        prevItem = item;
        return (
          <Fragment key={item.id}>
            {hasDividerDate && <TimeDivider time={item.sentAt} />}
            {isNewConsult && <ConsultDivider consultType={nextItem?.metadata?.consultType} />}
            {isNewPendingRequest && consultId && <AcceptedUnderInfo consultId={consultId} />}
            {isBotMessage ? (
              <MessageBotHOC
                message={item}
                isDoctor={isCurrentDoctorMessage}
                isBot={isBotMessage}
                openMedicalCertificate={openMedicalCertificate}
              />
            ) : (
              <MessageItem
                conversation={conversation}
                onSetReply={onSetReply}
                isDoctor={isCurrentDoctorMessage}
                message={item}
                patient={patient}
                prevMessage={tempPrevItem}
                avatar={avatarUrl}
                name={fullName}
                hasDividerDate={hasDividerDate}
                nextMessage={nextItem}
                userUuid={doctor.userUuid}
                openMedicalCertificate={openMedicalCertificate}
              />
            )}
          </Fragment>
        );
      })}
    </Item.Group>
  );
};

export default memo(MessageList);
